import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {invoice_lange} from "../../language/invoice";
import Swal from 'sweetalert2';
import { MyserviceService } from '../../provider/myservice.service';
import * as moment from 'moment';
import { DatatableComponent } from "@swimlane/ngx-datatable";

declare var report_url;
@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.scss']
})
export class InvoiceComponent implements OnInit {
  actions=[
    {id:0,action_type:{TH:"แสดงรายการการชำระ",EN:"Bill Data"}},
    {id:1,action_type:{TH:"ชำระเงิน",EN:"Pay"}},

  ]
  paybills:any;
  all_paybill:any;
  lang=localStorage.getItem('lang')=="EN"?"EN":"TH";
  language:any;
  isLoading=true;
  action=this.actions[0];
  paybill:any;
  vat_price=0;
  payments:any;
  submitted=false;
  paytype="";
  invoice:any;
  request_general:[];
  constructor(private route:ActivatedRoute,router:Router,private service:MyserviceService) { }

  ngOnInit() {
    this.refreshData();
    this.route.queryParams.subscribe(params => {
      this.lang= params['lang'];
      if(this.lang!='EN'&&this.lang!='TH'){
        this.lang=localStorage.getItem('lang')=='EN'?'EN':'TH';
        this.language=invoice_lange[this.lang];
      }else{
        this.language=invoice_lange[this.lang];
        localStorage.setItem('lang',this.lang);
      }
   });
  }
  onSearchFee_type(event){
    this.paybills=this.all_paybill.filter((item)=>{
      return compare(item.bill_id)||
      // compare(item.fee_id)||
      // compare(item.fee_description)||
      // compare(item.customer_id)||
      // compare(item.customer_name)||
      compare(item.user_id)||
      compare(item.createDate)||
      compare(item.pay_datetime);

    })
    // alert(1);
    function compare(type){
      return type.toLowerCase().indexOf(event.target.value.toLowerCase())>-1;
    }
  }
  refreshData(){
    this.submitted=false;
    this.action=this.actions[0];
    this.isLoading=true;
    var month;
    if(localStorage.getItem('month').length > 1){
      month = (localStorage.getItem('month')).match(/"([^']+)"/)[1];
    }else{
      month = localStorage.getItem('month');
    }
    var year = localStorage.getItem('year');
    console.log(month)
    this.service.postData({month:month,year:year},"bill/get").then((result:any)=>{
      //console.log(result);
      this.isLoading=false;
      this.all_paybill=result.data.filter((item)=>{
        var res:any;
        res=item;
        res.createDate=moment(item.create_datetime).format("DD/MM/YYYY");
        // res.dueDate=this.formatDate(new Date(item.due_date));

        res.pay_datetime=moment(res.pay_datetime).format("DD/MM/YYYY");
        return res;
      });
      this.paybills=this.all_paybill;
      localStorage.removeItem("month");
      localStorage.removeItem("year");
    },(err)=>{
      console.log(err);
    })
  }

  formatDate(date) {
    var monthNames = [
      "January", "February", "March",
      "April", "May", "June", "July",
      "August", "September", "October",
      "November", "December"
    ];

    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();
    var hour=date.getHours();
    var min=date.getMinutes();
    var sec=date.getSeconds();
    return day + ' ' + monthNames[monthIndex] + ' ' + year;
  }
  delete()
  {
    this.submitted=true;
    if (this.paybill.bill_request_general_id != '' && this.paybill.bill_request_general_id != undefined) 
    {
      Swal.fire({
        title: this.language.confirm_delete,
        text: this.language.warining_delete,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.language.want_delete,
        cancelButtonText: this.language.close
      }).then((result) => {
        if (result.value) 
        {
          this.service.postData({bill_id:this.paybill.bill_id},"invoice/cancel-invoice").then(result=>{
            this.isLoading=false;
            Swal.fire({
                title: this.language.deleted,
                text: '',
                type: 'success',
                showCancelButton: false,
                showConfirmButton: false,
                timer:2000
              }).then((result) => {
              this.refreshData();
            })
          },err=>{
            window.location.href=this.service.start_host
            this.isLoading=false;
          })
        }
      });
    }
  }

  print_bill(item){
      const municipality_id=this.service.getDatabase().substring(0,5);
      //window.open(report_url+"/print-invoice?bill_id="+item.bill_id+"&municipality_id="+municipality_id,"_blank");
      window.open(report_url+"print-bill?bill_id="+item.bill_id+"&municipality_id="+municipality_id,"_blank");
  }

  cancel_bill(row)
  {
    if (row != undefined) 
    {
      this.paybills=this.all_paybill.filter((item)=>item.bill_id==row.bill_id);
    }

    if(this.paybills.length>0)
    {
      if (this.paybills[0].flag == '1') 
      {
        Swal.fire({
          title: this.language.cancel_title,
          text: this.language.cancel_detail,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.language.confirm,
          cancelButtonText: this.language.cancel
        }).then((result) => {
          if (result.value) {
            this.service.postData({request_id:this.paybills[0].bill_id,flag:'0'}, "customer-request/update").then((result:any) => {
              if(!result.code){
                Swal.fire({
                      title: this.language.confirm,
                      text: '',
                      type: 'success',
                      showCancelButton: false,
                      showConfirmButton: false,
                      timer:2000
                }).then((result) => {
                  window.location.reload(); 
                })
              }
            }, err => {
              window.location.href=this.service.start_host
            })
          }
        })
      }
      else 
      {
        Swal.fire({
          title: this.language.inform_title,
          text: this.language.inform_detail,
          type: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: this.language.inform_confirm
        }).then((result) => {
          if (result.value) {}
        })
      }
      
    }
  }

  update(bill){
    this.paybill=bill;
    this.action=this.actions[1];
    this.isLoading=true;
    this.vat_price=0;
    //  this.isLoading=true;
    this.service.postData({bill_id:bill.bill_id},"bill/get-bill-invoice").then((result:any)=>{
      this.invoice=result.data;
      if(result.length>0){

        this.service.postData({customer_id:this.paybill.customer_id},"request-general/get").then((result2:any)=>
        {
          this.isLoading=false;
          this.request_general=JSON.parse(JSON.stringify(result2.data).replace(/\:null/gi, "\:\"\""))
          this.paybill.customer_id=result[0].customer_id;
          this.paybill.customer_name=result[0].customer_name;
          this.paybill.email=result[0].email
          this.paybill.mobile=result[0].mobile;
        })

        
      }
    },err=>{
      window.location.href=this.service.start_host
        // if(err.status=="500"){

        // }else{
        //   Swal.fire(err.message,'','error');
        // }
    })
    this.service.postData({},"payment-type/get").then((result:any)=>{
      this.payments=result.data;
      this.isLoading=false;

    },err=>{
      //console.log(err)
      window.location.href=this.service.start_host;
    })
  }
  back(){
    this.refreshData();
  }

}
